<div class="card card-custom">
  <form [formGroup]="form">
    <div class="card-header">
      <div class="br-light">
        <button
          type="button"
          [matTooltip]="'TASK.PRIORITY' | translate"
          [disabled]="!canEdit"
          style="border-top-left-radius: inherit !important"
          class="border-0 h-100 w-100"
          [ngClass]="getPriorityClass('BACKGROUND')"
          (click)="openSelectMenu($event, prioritySelect)"
        >
          <span
            inlineSVG="assets/media/svg/icons/General/Priority.svg"
            class="svg-icon svg-icon-lg"
            [ngClass]="getPriorityClass('SVG')"
          ></span>
        </button>
        <mat-form-field appearance="standard" class="hidden-field">
          <mat-select #prioritySelect formControlName="priority">
            <mat-option *ngFor="let priority of priorities" [value]="priority">
              <span
                inlineSVG="assets/media/svg/icons/General/Priority.svg"
                class="svg-icon svg-icon-sm mr-4"
                [ngClass]="getPriorityClass('SVG', priority)"
              ></span>
              {{ priority | titlecase }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="row m-0">
        <div class="col-8 d-flex align-items-center justify-content-between px-15px">
          <div class="d-flex align-items-center">
            <div class="mr-15px">
              <h3
                [hidden]="showTitleInput"
                class="m-0"
                [class.clickable]="canEdit"
                (click)="toggleTitle($event)"
              >
                {{ form.get('title').value }}
              </h3>
              <mat-form-field
                [hidden]="!showTitleInput"
                appearance="standard"
                style="min-width: 250px !important"
              >
                <mat-label>{{ 'TASK.TITLE' | translate }}</mat-label>
                <input
                  matInput
                  type="text"
                  formControlName="title"
                  required
                  (blur)="showTitleInput = !form.get('title').value"
                />
              </mat-form-field>
            </div>
            <button
              *ngIf="!!(form.get('templateResources$').value | async)?.length"
              type="button"
              [matTooltip]="'TASK.PROCESS_NAVIGATOR' | translate"
              class="btn btn-icon-cover btn-circle btn-white"
              (click)="openProcessNav($event)"
            >
              <span
                inlineSVG="assets/media/svg/icons/General/process-nav.svg"
                class="svg-icon svg-icon-light"
              ></span>
            </button>
          </div>
          <div class="d-flex align-items-center">
            <button
              type="button"
              [matTooltip]="'TASK.STATUS' | translate"
              [disabled]="isCreate || !canEdit"
              class="label label-xl label-inline border-0"
              [ngClass]="getStatusClass()"
              (click)="openSelectMenu($event, statusSelect)"
            >
              {{ form.get('status').value | enumFormat : '_' }}
            </button>
            <mat-form-field appearance="standard" class="hidden-field">
              <mat-select
                #statusSelect
                formControlName="status"
                (selectionChange)="handleStatusChange($event.value)"
              >
                <ng-container *ngFor="let status of statuses">
                  <mat-option
                    *ngIf="status !== Status.CANCELED || canCancelTask()"
                    [value]="status"
                  >
                    <span class="label label-lg label-inline" [ngClass]="getStatusClass(status)">{{
                      status | enumFormat : '_'
                    }}</span>
                  </mat-option>
                </ng-container>
              </mat-select>
            </mat-form-field>
            <ng-container *ngIf="showBlockersSelect">
              <div class="font-weight-bolder mx-4">{{ 'TASK.FOR' | translate }}</div>
              <mat-form-field appearance="standard" style="width: 150px !important">
                <mat-label>{{ 'TASK.BLOCKERS' | translate }}</mat-label>
                <mat-select
                  formControlName="blockers"
                  multiple
                  [compareWith]="compareBlockersFn"
                  (closed)="handleBlockersChange()"
                >
                  <mat-option *ngFor="let blocker of templateBlockers" [value]="blocker">
                    {{ blocker.description }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-container>
          </div>
        </div>
        <div class="col-4 d-flex align-items-center justify-content-end px-15px">
          <ng-container *ngIf="!!form.get('template').value">
            <div
              [matTooltip]="'TASK.TEAM' | translate"
              class="label label-xl label-inline label-light-dark"
            >
              {{ form.get('template').value.category_name }}
            </div>
          </ng-container>
        </div>
      </div>
      <div>
        <button
          mat-raised-button
          type="button"
          [matTooltip]="'GLOBAL.CLOSE' | translate"
          [disabled]="submitted"
          class="btn btn-icon btn-light"
          (click)="close($event)"
        >
          <span
            inlineSVG="assets/media/svg/icons/Navigation/Close.svg"
            class="svg-icon svg-icon-lg"
          ></span>
        </button>
      </div>
    </div>
    <div class="card-body">
      <div class="br-light">
        <ng-container *ngIf="forms.length > 1">
          <ng-container *ngFor="let form of forms; let idx = index">
            <ng-template #stepDetails>
              <div class="d-flex flex-column">
                <div class="d-flex align-items-center">
                  <span class="font-weight-bolder mr-4">{{ 'TASK.TITLE' | translate }}:</span>
                  <span class="flex-grow-1 text-left">{{ form.get('title').value || '-' }}</span>
                </div>
                <div class="d-flex align-items-center">
                  <span class="font-weight-bolder mr-4">{{ 'TASK.TEAM' | translate }}:</span>
                  <span class="flex-grow-1 text-left">{{
                    form.get('template').value?.category_name || '-'
                  }}</span>
                </div>
                <div class="d-flex align-items-center">
                  <span class="font-weight-bolder mr-4">{{ 'TASK.STATUS' | translate }}:</span>
                  <span class="flex-grow-1 text-left">{{
                    (form.get('status').value | enumFormat : '_') || '-'
                  }}</span>
                </div>
                <div class="d-flex align-items-center">
                  <span class="font-weight-bolder mr-4">{{ 'TASK.BLOCKERS' | translate }}:</span>
                  <span class="flex-grow-1 text-left">
                    <ng-container *ngIf="!form.get('blockers').value?.length">-</ng-container>
                    <ng-container *ngFor="let blocker of form.get('blockers').value; let i = index">
                      {{ blocker?.code }}
                      <ng-container *ngIf="i + 1 < form.get('blockers').value?.length"
                        >,</ng-container
                      >
                    </ng-container>
                  </span>
                </div>
              </div>
            </ng-template>
            <div
              [ngbTooltip]="stepDetails"
              [class.active]="idx + 1 === activeOrder"
              [class.clickable]="idx + 1 !== activeOrder"
              class="btn-step bb-light"
              (click)="activateStep($event, idx + 1)"
            >
              <div
                [ngClass]="getStepStatusClass(form.get('status').value, idx + 1 === currentOrder)"
              >
                {{ idx + 1 }}
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
      <div class="br-light row m-0">
        <div class="col-8 var-area br-light">
          <div class="var-area-header bb-light">
            <h6
              class="flex-grow-1 d-flex flex-column align-items-stretch justify-content-center m-0"
            >
              <span class="text-dark-50">{{ viewSelect.value | enumFormat : '_' }}</span>
              <span style="font-size: 0.9em !important">{{ variableArea.title | titlecase }}</span>
            </h6>
            <div>
              <button
                type="button"
                [matTooltip]="'TASK.VIEW' | translate"
                class="btn btn-icon btn-white"
                (click)="openSelectMenu($event, viewSelect)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/Layout/Four-squares.svg"
                  class="svg-icon svg-icon-lg svg-icon-light"
                ></span>
              </button>
              <mat-form-field appearance="standard" class="hidden-field">
                <mat-select #viewSelect (selectionChange)="activateView($event.value)">
                  <mat-option *ngFor="let view of varAreaViews" [value]="view"
                    >{{ view | enumFormat : '_' }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="var-area-body scroll" [perfectScrollbar]="{ wheelPropagation: false }">
            <ng-container
              *ngIf="showChecklistError"
              [ngTemplateOutlet]="errorAlert"
              [ngTemplateOutletContext]="{
                message:
                  'Unable to set the Task step as &quot;DONE&quot; unless you mark all checklist items as completed.'
              }"
            ></ng-container>
            <ng-container
              *ngIf="showFormioError"
              [ngTemplateOutlet]="errorAlert"
              [ngTemplateOutletContext]="{
                message:
                  'Unable to set the Task step as &quot;DONE&quot; unless you fill out all required fields in the form.'
              }"
            ></ng-container>
            <ng-container
              *ngIf="actionMapperEntityError.show"
              [ngTemplateOutlet]="errorAlert"
              [ngTemplateOutletContext]="{ message: actionMapperEntityError.message }"
            ></ng-container>
            <ng-container
              *ngIf="actionMapperFormError.show"
              [ngTemplateOutlet]="errorAlert"
              [ngTemplateOutletContext]="{ message: actionMapperFormError.message }"
            ></ng-container>
            <kt-task-variable-area-view
              #variableArea
              [data]="activeViewData"
              (inputChange)="handleVarAreaInputChange($event)"
            ></kt-task-variable-area-view>
          </div>
        </div>
        <div class="col-4 scroll p-15px" [perfectScrollbar]="{ wheelPropagation: false }">
          <div class="d-flex align-items-center justify-content-between mb-15px">
            <div class="assignees">
              <div
                *ngFor="let assignee of form.get('assignees').value"
                [ktHoverClass]="canEdit ? 'show-remove' : ''"
                class="profile-pic"
              >
                <button
                  type="button"
                  class="btn btn-remove btn-circle btn-light-danger btn-hover-danger"
                  (click)="unassign($event, assignee)"
                >
                  <span
                    inlineSVG="assets/media/svg/icons/Navigation/Close.svg"
                    class="svg-icon svg-icon-danger"
                  ></span>
                </button>
                <kt-user-photo
                  [matTooltip]="assignee.fullName"
                  [size]="34"
                  [editable]="false"
                  [type]="fetchUser ? 'observable' : 'object'"
                  [user$]="fetchUser ? getUser$(assignee.responsible_id) : assignee"
                ></kt-user-photo>
              </div>
              <div class="btn-group bg-white rounded-circle">
                <button
                  type="button"
                  data-toggle="dropdown"
                  [matTooltip]="'TASK.ASSIGN_USER' | translate"
                  [disabled]="!canEdit"
                  class="btn btn-icon-cover btn-circle btn-white dropdown-toggle"
                  (dblclick)="pickup($event)"
                >
                  <span
                    inlineSVG="assets/media/svg/icons/Communication/Assign-user.svg"
                    class="svg-icon svg-icon-light"
                  ></span>
                </button>
                <div class="dropdown-menu dropdown-menu-left dropdown-menu-anim-up px-15px py-0">
                  <kt-general-autocomplete
                    #assigneeAutocomplete
                    [label]="'TASK.ASSIGNEE' | translate"
                    [appearance]="'standard'"
                    [dataPath]="'data'"
                    [loadItemsFunction]="getUserAutocomplete$"
                    [optionFormatter]="formatUserOption"
                    [valueFormatter]="formatUserOption"
                    [change]="handleAssigneeChange.bind(this)"
                  ></kt-general-autocomplete>
                </div>
              </div>
            </div>
            <div class="followers btn-group">
              <button
                type="button"
                [matTooltip]="'TASK.ADD_FOLLOWER' | translate"
                class="btn btn-icon-cover btn-circle btn-white"
                (click)="toggleDropdownMenu($event, followersMenu)"
              >
                <span
                  *ngIf="!!form.get('followers').value.length"
                  class="badge badge-info d-flex flex-center"
                  >{{ form.get('followers').value.length }}</span
                >
                <span
                  inlineSVG="assets/media/svg/icons/Communication/View.svg"
                  class="svg-icon svg-icon-light"
                ></span>
              </button>
              <div
                #followersMenu
                class="dropdown-menu dropdown-menu-manual dropdown-menu-anim-up p-0"
              >
                <div class="bb-light px-15px w-100">
                  <kt-general-autocomplete
                    #followerAutocomplete
                    [label]="'TASK.FOLLOWER' | translate"
                    [appearance]="'standard'"
                    [dataPath]="'data'"
                    [loadItemsFunction]="getUserAutocomplete$"
                    [optionFormatter]="formatUserOption"
                    [valueFormatter]="formatUserOption"
                    [change]="handleFollowerChange.bind(this)"
                    [readOnly]="!canEdit"
                  ></kt-general-autocomplete>
                </div>
                <div
                  *ngIf="!!form.get('followers').value.length"
                  style="max-height: 200px !important"
                  class="d-flex flex-column scroll py-15px"
                  [perfectScrollbar]="{ wheelPropagation: false }"
                >
                  <div
                    *ngFor="let follower of form.get('followers').value"
                    class="d-flex align-items-center bg-hover-light px-15px py-2"
                  >
                    <kt-user-photo
                      [size]="24"
                      [editable]="false"
                      [type]="fetchUser ? 'observable' : 'object'"
                      [user$]="fetchUser ? getUser$(follower.follower_id) : follower"
                    ></kt-user-photo>
                    <div class="flex-grow-1 d-flex align-items-center justify-content-between ml-4">
                      <span>{{ follower.fullName }}</span>
                      <button
                        type="button"
                        class="btn btn-remove btn-circle btn-light-danger btn-hover-danger"
                        [disabled]="!canEdit"
                        (click)="unfollow($event, follower)"
                      >
                        <span
                          inlineSVG="assets/media/svg/icons/Navigation/Close.svg"
                          class="svg-icon svg-icon-danger"
                        ></span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="entities d-flex align-items-start mb-15px">
            <div class="btn-group">
              <button
                type="button"
                [matTooltip]="'TASK.ASSIGN_ENTITIES' | translate"
                class="btn btn-icon-cover btn-circle btn-white"
                (click)="toggleDropdownMenu($event, entitiesMenu)"
              >
                <span
                  inlineSVG="assets/media/svg/icons/Communication/Add-entity2.svg"
                  class="svg-icon svg-icon-light"
                ></span>
              </button>
              <div
                #entitiesMenu
                class="dropdown-menu dropdown-menu-manual dropdown-menu-lg dropdown-menu-anim-up p-0"
              >
                <div class="bb-light px-15px">
                  <mat-form-field appearance="standard" class="w-100">
                    <mat-label>{{ 'TASK.ENTITY_TYPE' | translate }}</mat-label>
                    <mat-select
                      #entityTypeSelect
                      [disabled]="!canEdit"
                      (selectionChange)="handleEntityTypeChange($event.value)"
                    >
                      <mat-option *ngFor="let type of entityTypes" [value]="type"
                        >{{ type | enumFormat : '_' }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div
                    style="max-height: 200px !important"
                    class="scroll w-100"
                    [perfectScrollbar]="{ wheelPropagation: false }"
                  >
                    <kt-general-autocomplete
                      #entitiesAutocomplete
                      [label]="'TASK.ENTITIES' | translate"
                      [appearance]="'standard'"
                      [chipList]="true"
                      [dataPath]="'data'"
                      [objects]="entitiesAutocomplete.value"
                      [loadItemsFunction]="getEntitiesAutocomplete$"
                      [optionFormatter]="stringUtils.formatEntityOptionActiveInactive"
                      [chipOptionFormatter]="stringUtils.formatEntityValueActiveInactive"
                      [formatNewObjectFn]="formatNewEntity"
                      [readOnly]="!entityTypeSelect.value || !canEdit"
                    ></kt-general-autocomplete>
                  </div>
                </div>
                <div class="d-flex justify-content-end px-15px py-2">
                  <button
                    type="button"
                    style="min-width: 100px !important"
                    class="btn btn-sm btn-secondary"
                    [disabled]="!canEdit"
                    (click)="handleEntities($event, entitiesMenu)"
                  >
                    {{ 'GLOBAL.SAVE' | translate }}
                  </button>
                </div>
              </div>
            </div>
            <kt-format-task-entities [entities$]="entities$"></kt-format-task-entities>
          </div>
          <div class="d-flex flex-column mb-15px">
            <button
              type="button"
              [disabled]="!canEdit"
              class="btn btn-sm"
              [ngClass]="getDueDateStatusClass()"
              [owlDateTimeTrigger]="dueDatePicker"
            >
              {{ dueDateStatus | dueDateStatusFormat : form.get('dueDate').value }}
            </button>
            <input
              matInput
              [owlDateTime]="dueDatePicker"
              class="hidden-field"
              (dateTimeChange)="handleDueDateChange($event.value)"
            />
            <owl-date-time
              #dueDatePicker
              [hour12Timer]="true"
              [disabled]="!canEdit"
            ></owl-date-time>
          </div>
          <div class="url-resource d-flex align-items-center mb-15px">
            <div class="flex-grow-1">
              <mat-form-field [hidden]="showLink" appearance="standard" class="w-100">
                <mat-label>{{ 'TASK.URL_RESOURCE' | translate }}</mat-label>
                <input
                  #urlResourceInput
                  matInput
                  type="url"
                  formControlName="urlResource"
                  placeholder="ex: https://example.com"
                  (focus)="handleShowLink($event, false)"
                  (blur)="
                    handleShowLink(
                      $event,
                      !!form.get('urlResource').value && !isInvalid('urlResource')
                    )
                  "
                />
                <mat-error *ngIf="isInvalid('urlResource')"
                  >{{
                    'TASK.VALIDATION.INVALID'
                      | translate : { label: 'TASK.URL_RESOURCE' | translate }
                  }}
                </mat-error>
              </mat-form-field>
              <div [hidden]="!showLink" class="w-100">
                <button
                  *ngIf="form.get('urlResource').value as url"
                  class="btn btn-link"
                  (click)="openLink($event, url)"
                >
                  {{ url }}
                </button>
              </div>
            </div>
            <button
              type="button"
              [matTooltip]="'TASK.URL_RESOURCE' | translate"
              [disabled]="!canEdit"
              class="btn btn-icon btn-white ml-15px"
              (click)="handleShowLink($event, false, urlResourceInput)"
            >
              <span
                inlineSVG="assets/media/svg/icons/General/link-1.svg"
                class="svg-icon svg-icon-light"
              ></span>
            </button>
          </div>
          <div class="w-100 mb-15px">
            <kt-general-autocomplete
              #officeAutocomplete
              [required]="true"
              [label]="'TASK.OFFICE' | translate"
              [appearance]="'standard'"
              [dataPath]="'data'"
              [loadItemsFunction]="getOfficeAutocomplete$"
              [optionFormatter]="formatOfficeOption"
              [valueFormatter]="formatOfficeOption"
              [readOnly]="!canEdit"
              [change]="handleOfficeChange.bind(this)"
            ></kt-general-autocomplete>
          </div>
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>{{ 'TASK.DESCRIPTION' | translate }}</mat-label>
            <textarea
              matInput
              formControlName="description"
              rows="6"
              class="scroll"
              [perfectScrollbar]="{ wheelPropagation: false }"
            ></textarea>
          </mat-form-field>
          <div *ngIf="!isCreate && data.task?.id" class="w-100 mb-15px">
            <kt-task-agent-hitl
              [taskId]="data.task.id"
              [runId]="agentRunId"
              (refreshTask)="reloadTask()"
            ></kt-task-agent-hitl>
          </div>
          <div *ngIf="templateAi" class="w-100 mb-15px p-4 border rounded">
            <div class="font-weight-bolder mb-3">AI definition</div>
            <div *ngIf="templateAi.objective" class="mb-3">
              <div class="text-muted font-size-sm">Objective</div>
              <div style="white-space: pre-wrap">{{ templateAi.objective }}</div>
            </div>
            <div *ngIf="templateAi.critical_data" class="mb-3">
              <div class="text-muted font-size-sm">Critical data</div>
              <div style="white-space: pre-wrap">{{ templateAi.critical_data }}</div>
            </div>
            <div *ngIf="templateAi.data_sources" class="mb-3">
              <div class="text-muted font-size-sm">Data sources</div>
              <div style="white-space: pre-wrap">{{ templateAi.data_sources }}</div>
            </div>
            <div *ngIf="templateAi.authorized_communication_methods?.length">
              <div class="text-muted font-size-sm">Authorized communication</div>
              <div>{{ templateAi.authorized_communication_methods.join(', ') }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-column align-items-center py-15px">
        <div class="flex-grow-1 d-flex flex-column">
          <div class="btn-group">
            <button
              mat-raised-button
              type="button"
              data-toggle="dropdown"
              [matTooltip]="'TASK.ATTACHMENTS' | translate"
              class="btn btn-icon btn-light dropdown-toggle symbol"
            >
              <span
                inlineSVG="assets/media/svg/icons/Files/Clip.svg"
                class="svg-icon svg-icon-lg symbol-label"
              ></span>
              <span
                class="symbol-badge"
                [ngClass]="
                  !!prevAttachments?.length || !!newAttachments?.length
                    ? 'bg-danger'
                    : 'bg-secondary'
                "
              ></span>
            </button>
            <div
              class="dropdown-menu dropdown-menu-lg dropdown-menu-right dropdown-menu-anim-up p-0"
            >
              <div class="bb-light p-15px">
                <button
                  type="button"
                  [disabled]="!canEdit"
                  class="btn btn-sm btn-secondary w-100"
                  (click)="attachmentsInput.click()"
                >
                  {{ 'TASK.ADD_ATTACHMENTS' | translate }}
                </button>
                <input
                  #attachmentsInput
                  type="file"
                  multiple
                  hidden
                  (change)="addAttachments($event)"
                />
              </div>
              <div
                *ngIf="!!newAttachments.length || !!prevAttachments.length"
                style="max-height: 200px !important"
                class="d-flex flex-column scroll my-15px"
                [perfectScrollbar]="{ wheelPropagation: false }"
              >
                <ng-container
                  *ngFor="let file of newAttachments; let idx = index"
                  [ngTemplateOutlet]="attachment"
                  [ngTemplateOutletContext]="{
                    file: file,
                    index: idx,
                    isNew: true,
                    attachments: newAttachments
                  }"
                ></ng-container>
                <ng-container
                  *ngFor="let file of prevAttachments; let idx = index"
                  [ngTemplateOutlet]="attachment"
                  [ngTemplateOutletContext]="{
                    file: file,
                    index: idx,
                    isNew: false,
                    attachments: prevAttachments
                  }"
                ></ng-container>
              </div>
            </div>
          </div>
          <button
            *ngIf="!isCreate"
            mat-raised-button
            type="button"
            [matTooltip]="'TASK.SHARE' | translate"
            class="btn btn-icon btn-light mt-15px"
            (click)="shareDocument($event)"
          >
            <span
              inlineSVG="assets/media/svg/icons/Communication/Share.svg"
              class="svg-icon svg-icon-lg"
            ></span>
          </button>
          <button
            *ngIf="!isCreate && !data.fromCalendar"
            mat-raised-button
            type="button"
            [matTooltip]="'TASK.FOLLOW_UP' | translate"
            class="btn btn-icon btn-light mt-15px symbol"
            (click)="openFollowUp($event)"
          >
            <span
              inlineSVG="assets/media/svg/icons/Communication/Calendar-clock.svg"
              class="svg-icon svg-icon-lg"
            ></span>
            <span *ngIf="checkFollowupExist(data)" class="symbol-badge bg-danger"></span>
          </button>

          <button
            *ngIf="!isCreate && !!relatedTemplates.length"
            mat-raised-button
            type="button"
            [matTooltip]="'TASK.CREATE_RELATED_TASK' | translate"
            class="btn btn-icon btn-light mt-15px"
            (click)="createRelatedTask($event)"
          >
            <span
              inlineSVG="assets/media/svg/icons/Communication/Related-task.svg"
              class="svg-icon svg-icon-lg"
            ></span>
          </button>
          <ng-template ngxPermissionsOnly="canProcessPayment">
            <button
              *ngIf="!isCreate && taskAllowPayment"
              type="button"
              [matTooltip]="'Process Payment' | translate"
              class="btn btn-icon btn-light mt-15px"
              (click)="processPayment($event)"
            >
              <span
                class="svg-icon svg-icon-lg"
                inlineSVG="assets/media/svg/icons/General/dollar.svg"
              ></span>
              <span
                *ngIf="paidSuccessfully"
                [matBadge]="'Paid'"
                matBadgeSize="medium"
                [matBadgeHidden]="false"
                matBadgeColor="warn"
                style="top: -15px; border-radius: 0; right: -8px"
              ></span>
            </button>
          </ng-template>
        </div>
        <button
          *ngIf="!isCreate && viewSelect.value !== VarAreaView.COMMENTS"
          mat-raised-button
          type="button"
          [matTooltip]="'TASK.COMMENTS' | translate"
          matTooltipPosition="above"
          class="btn btn-icon btn-light symbol"
          (click)="toggleComments($event)"
        >
          <span
            inlineSVG="assets/media/svg/icons/Communication/Group-chat.svg"
            class="svg-icon svg-icon-lg symbol-label"
          ></span>
          <span
            class="symbol-badge"
            [ngClass]="!!comments.length ? 'bg-danger' : 'bg-secondary'"
          ></span>
        </button>
      </div>
    </div>

    <div class="border-top pt-5 ks-pl-8" *ngIf="showProgressDetails">
      <div class="row">

        <div class="col-md-3 mb-3">
          <div class="text-muted font-size-sm">Completed by:</div>
          <div class="d-flex align-items-center mt-2">
            <div class="symbol symbol-35 symbol-light-primary symbol-circle mr-3">
            </div>
            <div>
              <div *ngIf="isCompletedByInternal" class="font-weight-bolder font-size-lg">
                {{ completedByName }}
                <small class="text-muted ml-2">(Internal)</small>
              </div>
              <div  *ngIf="isCompletedByExternal" class="font-weight-bolder font-size-lg mt-2">
                {{ completedByName }}
                <small class="text-muted ml-2">(External)</small>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3 mb-3" *ngIf="completedAt as completedAt">
          <div class="text-muted font-size-sm">Completed at:</div>
          <div class="font-weight-bolder font-size-lg mt-2">
            {{ completedAt | date: 'medium' }}
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="tags btn-group dropup">
        <button
          type="button"
          [matTooltip]="'TASK.ADD_TAGS' | translate"
          matTooltipPosition="above"
          class="btn btn-icon-cover btn-circle btn-white symbol"
          (click)="toggleDropdownMenu($event, tagsMenu)"
        >
          <span
            inlineSVG="assets/media/svg/icons/Files/Tag.svg"
            class="svg-icon svg-icon-light symbol-label"
          ></span>
          <span
            class="symbol-badge"
            [ngClass]="tagsAutocomplete.value?.length ? 'bg-danger' : 'bg-secondary'"
          ></span>
        </button>
        <div
          #tagsMenu
          class="dropdown-menu dropdown-menu-manual dropdown-menu-lg dropdown-menu-anim-up p-0"
        >
          <div class="bb-light px-15px">
            <div
              style="max-height: 200px !important"
              class="scroll w-100"
              [perfectScrollbar]="{ wheelPropagation: false }"
            >
              <kt-general-autocomplete
                #tagsAutocomplete
                [label]="'TASK.TAGS' | translate"
                [appearance]="'standard'"
                [chipList]="true"
                [dataPath]="'data'"
                [objects]="tagsAutocomplete.value"
                [loadItemsFunction]="getTagsAutocomplete$"
                [optionFormatter]="formatTagOption"
                [valueFormatter]="formatTagOption"
                [formatNewObjectFn]="formatNewTag"
                [readOnly]="!canEdit"
              ></kt-general-autocomplete>
            </div>
          </div>
          <div class="d-flex justify-content-end px-15px py-2">
            <button
              type="button"
              [disabled]="!canEdit"
              style="min-width: 100px !important"
              class="btn btn-sm btn-secondary"
              (click)="toggleDropdownMenu($event, tagsMenu)"
            >
              {{ 'GLOBAL.CLOSE' | translate }}
            </button>
          </div>
        </div>
      </div>
      <div style="justify-content: space-between !important" class="px-15px">
        <div>
          <span *ngIf="form.get('created').value as created" class="mr-15px">
            <span class="font-weight-bolder mr-2">{{ 'TASK.CREATED' | translate }}:</span
            >{{ created | date : 'yyyy-MM-dd hh:mm' }}
          </span>
          <span *ngIf="form.get('id').value as stepId" class="mr-15px">
            <span class="font-weight-bolder mr-2">{{ 'TASK.TASK_ID' | translate }}:</span
            >{{ data.task?.id }}.{{ stepId }}
          </span>
          <span *ngIf="form.get('template').value?.id as templateId">
            <span class="font-weight-bolder mr-2">{{ 'TASK.TEMPLATE_ID' | translate }}:</span
            >{{ templateId }}
          </span>
        </div>
        <div>
          <button
            mat-raised-button
            type="button"
            [disabled]="submitted"
            class="btn btn-sm btn-light"
            (click)="close($event)"
          >
            {{ 'GLOBAL.CANCEL' | translate }}
          </button>
          <button
            mat-raised-button
            type="button"
            [disabled]="!canEdit || submitted || requiredFieldsEmpty()"
            class="btn btn-sm btn-primary ml-15px"
            (click)="save($event)"
          >
            <ng-container *ngIf="!submitted"> {{ 'GLOBAL.SAVE' | translate }}</ng-container>
            <ng-container *ngIf="submitted">
              <span class="spinner-border spinner-border-sm"></span>
              {{ 'GLOBAL.SAVING' | translate }}
            </ng-container>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<ng-template
  #attachment
  let-file="file"
  let-index="index"
  let-isNew="isNew"
  let-attachments="attachments"
>
  <div class="d-flex align-items-center bg-hover-light px-15px py-2">
    <div
      class="flex-grow-1 d-flex align-items-center"
      [ngClass]="{ 'btn btn-link': !isNew }"
      (click)="openLink($event, file.url)"
    >
      <span
        [inlineSVG]="getAttachmentIcon(isNew ? file.name : file.path)"
        class="svg-icon svg-icon-lg m-0"
      ></span>
      <span class="text-lines-2 no-hover ml-2">{{
        isNew ? file.name : file.path.substring(file.path.lastIndexOf('/') + 1)
      }}</span>
    </div>
    <div
      style="min-width: 45px !important"
      class="d-flex align-items-center ml-2"
      [ngClass]="attachments[index]?.id ? 'justify-content-between' : 'justify-content-end'"
    >
      <button
        *ngIf="attachments[index]?.id"
        type="button"
        class="btn btn-remove btn-circle btn-light-warning btn-hover-warning"
        [disabled]="!canEdit"
        (click)="shareAttachment($event, attachments, index)"
      >
        <span
          inlineSVG="assets/media/svg/icons/Communication/Send.svg"
          class="svg-icon svg-icon-warning"
        ></span>
      </button>
      <button
        type="button"
        class="btn btn-remove btn-circle btn-light-danger btn-hover-danger"
        [disabled]="!canEdit"
        (click)="removeAttachment($event, attachments, index)"
      >
        <span
          inlineSVG="assets/media/svg/icons/Navigation/Close.svg"
          class="svg-icon svg-icon-danger"
        ></span>
      </button>
    </div>
  </div>
</ng-template>

<ng-template #errorAlert let-message="message">
  <div class="p-15px">
    <div class="alert alert-custom alert-light-danger fade show px-15px py-2 m-0">
      <div class="alert-icon">
        <i style="font-size: 1.6rem !important" class="flaticon-warning"></i>
      </div>
      <div class="alert-text">{{ message }}</div>
    </div>
  </div>
</ng-template>

